import { render, staticRenderFns } from "./MedicineAdd.vue?vue&type=template&id=70ea78b2&scoped=true&"
import script from "./MedicineAdd.vue?vue&type=script&lang=js&"
export * from "./MedicineAdd.vue?vue&type=script&lang=js&"
import style0 from "./MedicineAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MedicineAdd.vue?vue&type=style&index=1&id=70ea78b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea78b2",
  null
  
)

export default component.exports